interface Fields {
  name: string;
  translationKey: string;
}

export default class BusinessPartner implements Fields {
  name = '';
  translationKey = '';

  constructor(props?: Partial<Fields>) {
    return {
      ...this,
      ...props,
    };
  }
}
